import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { LANGUAGES } from './RecommendationCropDetail';

const CropStages = ({ stages, onSave, viewMode }) => {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const emptyI18n = () => Object.fromEntries(LANGUAGES.map((l) => [l, '']));

  useEffect(() => {
    setItems(
      stages.length
        ? stages.map((s) => ({
            id: s.id,
            order: s.order,
            orderName: s.orderName || s.order_name_i18n || emptyI18n(),
          }))
        : [{ id: null, order: 1, orderName: emptyI18n() }]
    );
  }, [stages]);

  const addStage = () => {
    setItems((prev) => [...prev, { id: null, order: prev.length + 1, orderName: emptyI18n() }]);
  };

  const removeStage = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index).map((s, i) => ({ ...s, order: i + 1 })));
  };

  const setOrderName = (index, lang, value) => {
    setItems((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], orderName: { ...next[index].orderName, [lang]: value } };
      return next;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    try {
      const payload = items.map((item, i) => ({
        id: item.id,
        order: i + 1,
        orderName: item.orderName,
      }));
      await onSave(payload);
      setMessage('Saved successfully! Translations will be generated in the background.');
    } catch (err) {
      setMessage(err.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  if (viewMode) {
    return (
      <div className="card p-3">
        <h5 className="mb-3">Growth stages</h5>
        {items.map((item, index) => {
          const visibleLangs = LANGUAGES;
          return (
            <div key={index} className="border rounded p-3 mb-3 bg-light">
              <strong className="d-block mb-1 text-primary">Stage {index + 1}</strong>
              {visibleLangs.map((lang) => (
                <div key={lang} className="mb-2">
                  <label className="form-label small text-capitalize text-muted mb-0">{lang}</label>
                  <p className="mb-0">{item.orderName[lang] || '—'}</p>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="card p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Growth stages</h5>
        <Button variant="outline-primary" size="sm" onClick={addStage}>
          Add stage
        </Button>
      </div>
      <form onSubmit={handleSubmit}>
        {items.map((item, index) => {
          const visibleLangs = LANGUAGES;
          return (
            <div key={index} className="border rounded p-3 mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <strong>Stage {index + 1}</strong>
                <Button variant="outline-danger" size="sm" onClick={() => removeStage(index)} disabled={items.length <= 1}>
                  Remove
                </Button>
              </div>
              <div className="row">
                {visibleLangs.map((lang) => (
                  <div key={lang} className="col-md-6 mb-2">
                    <label className="form-label small text-capitalize text-muted">{lang} Stage Name</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder={`Enter in ${lang}...`}
                      value={item.orderName[lang] || ''}
                      onChange={(e) => setOrderName(index, lang, e.target.value)}
                    />
                  </div>
                ))}
              </div>
            </div>
          );
        })}
        {message && (
          <div className={`mb-2 text-small ${message.includes('failed') ? 'text-danger' : 'text-success'}`}>
            {message}
          </div>
        )}
        <Button type="submit" variant="primary" disabled={saving}>
          {saving ? 'Saving…' : 'Save stages'}
        </Button>
      </form>
    </div>
  );
};

export default CropStages;
